/**
 * This promise lets consuming clients wait on the diagnostics initialization before
 * performing any diagnostic operations.
 * This makes sure that we don't loose out on any diagnostics events before init.
 *
 * e.g. LSR diagnostics are fired before the diagnostics is initialized as part of post boot.
 *
 * Lazy resolve pattern similar to OpxHostOutlook used in client-web
 */
export let resolveDiagnosticsInitialization: (() => void) | undefined;

// tslint:disable-next-line promise-must-complete
const diagnosticsInitializationPromise: Promise<void> = new Promise(resolve => {
    resolveDiagnosticsInitialization = resolve;
});

export const waitForDiagnosticsInitialization = () => diagnosticsInitializationPromise;
